import { NavigationPeriodId } from '../../common/constants';
import { messages as commonMessages } from '../../common/messages';

export const navigationLabels = {
	[NavigationPeriodId.OneDay]: commonMessages.day,
	[NavigationPeriodId.OneWeek]: commonMessages.week,
	[NavigationPeriodId.TwoWeeks]: commonMessages.twoWeeks,
	[NavigationPeriodId.OneMonth]: commonMessages.month,
};

export const timelineTypeNames = {
	[NavigationPeriodId.OneDay]: 'oneDay',
	[NavigationPeriodId.OneWeek]: 'oneWeek',
	[NavigationPeriodId.TwoWeeks]: 'twoWeeks',
	[NavigationPeriodId.OneMonth]: 'oneMonth',
};
